import type { SidePanel } from '../types';

export const ChooseBorrowerBankAccountPanel: SidePanel.VueComponent = {
  component: defineAsyncComponent(() => import('./ChooseBorrowerBankAccountPanel.vue')),
};
